import { cn } from "@universe/ui/lib/utils";
import Image from "next/image";

type LogoSize = "sm" | "md" | "lg";
type LogoVariant = "blue" | "white";

export interface UPLogoProps {
  size?: LogoSize;
  width?: number;
  height?: number;
  className?: string;
  id?: string;
  variant?: LogoVariant;
  onClick?: () => void;
  overrideSrc?: string;
}

const sizeMap: Record<LogoSize, { width: number; height: number }> = {
  sm: { width: 80, height: 80 },
  md: { width: 120, height: 120 },
  lg: { width: 220, height: 220 },
};

export const UPLogo = ({
  size = "md",
  width,
  height,
  className = "",
  variant = "white",
  onClick,
  overrideSrc,
  ...rest
}: UPLogoProps) => {
  const dimensions = sizeMap[size];
  const finalWidth = width ?? dimensions.width;
  const finalHeight = height ?? dimensions.height;

  return (
    <div
      onClick={onClick}
      className={cn(onClick && "cursor-pointer hover:opacity-80", className)}
    >
      {/* @ts-expect-error - causing issues in storybook */}
      <Image
        overrideSrc={overrideSrc || `/images/um-logo-${variant}.png`}
        alt="UP Logo"
        width={finalWidth}
        height={finalHeight}
        className={className}
        priority
        {...rest}
      />
    </div>
  );
};

export default UPLogo;
